import * as z from "zod";
import { recordConnectorUsage, usageRef } from "../connectorUsages";
import { mutator } from "./mutator";

export const createAuditLogDestinationSchema = z.object({
  id: z.string(),
  name: z.string().min(1),
  url: z.string().url().startsWith("https://"),
  method: z.enum(["PUT", "POST"]),
  connectedAppId: z.string().nullable().optional(),
});

export const createAuditLogDestination = mutator({
  schema: createAuditLogDestinationSchema,
  resolve: {},
  permissions: [
    {
      permission: "tenant:audit_logs_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
    {
      permission: "connected_app:use",
      scopeId: ({ args }) => args.connectedAppId ?? null,
    },
  ],
  fn: async ({ tx, ctx, args: { id, name, url, method, connectedAppId } }) => {
    await tx.mutate.auditLogDestinations.insert({
      id,
      name,
      url,
      method,
      cursorTimestamp: Date.now(),
      lastError: null,
      tenantId: ctx.tenantId,
    });
    if (connectedAppId) {
      await recordConnectorUsage(
        tx,
        connectedAppId,
        usageRef.auditLogDestination(id),
        ctx.tenantId
      );
    }
  },
});
